export const ALERT_TYPES = {
  Primary: "primary",
  Seconday: "secondary",
  Success: "success",
  Danger: "danger",
  Warning: "warning",
  Info: "info",
  Light: "light",
  Dark: "dark"
};

// action types
export const LOAD_DATA = "getList";
export const GET_RECORD = "getRecord";
// export const VIEW_RECORD = "viewRecord";
export const ADD_RECORD = "addRecord";
export const UPDATE_RECORD = "updateRecord";
export const DELETE_RECORD = "deleteRecord";

// mutation types
export const SET_PAGE = "updateCurrentPage";
export const SET_DATA = "setData";
export const SET_ACTIVE_DATA = "setActiveRecord";
export const SET_ERROR = "setError";
export const IS_LOADING = "isLoading";
export const UPDATE_DATA_ROW = "updateDataRow";
